module.exports = __webpack_public_path__ + "img/worldofzain.8134ee43.jpg";